<template lang="pug">
div
    div(v-for="product in orderProducts", :class="{'text-muted': product.voided_by !== null}")
        div.row
            div.col-xs-7
                small {{ orderProductName(product) }}
                div(v-if="product.voided_by !== null")
                  span.block(v-if="product.void_remarks !== ''")
                    i.material-icons.voided &#xe15c;
                    small.m-l-xs {{ product.void_remarks }}
                  span.block
                    i.material-icons.voided &#xe7fd;
                    small.m-l-xs {{ product.voided_staff.name }}
            div.col-xs-1
                small.pull-right {{ product.quantity }}x
            div.col-xs-1
                small(v-if="product.tax !== null && product.product_id !== null").grand-total-amount.tax {{ product.tax.tax.short_name }}
            div.col-xs-3
                small.pull-right {{ orderProductPrice(product) }}

        div.row(v-for="modifier in product.modifiers")
            div.col-xs-7
                small.m-l-md {{ orderProductModifierName(modifier) }}
            div.col-xs-1
                small.pull-right {{ modifier.quantity }}x
            div.col-xs-1
            div.col-xs-3
                small.pull-right {{ orderProductModifierPrice(modifier, product) }}

    div.row
        div.col-xs-12
            hr
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters, mapActions } from 'vuex';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transaction', [
            'receipt',
            'hasTransaction',
            'isVoided',
            'outlet',
            'table',
            'orderTable',
            'orderProducts',
            'cashier',
        ]),
    },
};
</script>

<style lang="scss">
.voided {
    font-size: 14px;
    vertical-align: middle;
}

.tax {
    padding: 1px;
    border: 1px solid !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/orders.vue